import "./baseConfig/font.css.ts.vanilla.mjs";
import "./baseConfig/global.css.ts.vanilla.mjs";
import "./button.css.ts.vanilla.mjs";
var r = "p273__button-8704_fc0c7e7bf__dvf5eq0";
export {
  r as buttonStyle
};
//# sourceMappingURL=button.mjs.map
